var d = Object.defineProperty;
var w = (n, r, e) => r in n ? d(n, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[r] = e;
var a = (n, r, e) => (w(n, typeof r != "symbol" ? r + "" : r, e), e);
class N {
  constructor(r) {
    a(this, "normalizers");
    this.normalizers = r;
  }
  convertObjectToFormData(r) {
    let e = new FormData();
    for (const o in r) {
      if (!r.hasOwnProperty(o) || r[o] === void 0)
        continue;
      const t = r[o];
      let i = !1;
      for (const l of this.normalizers)
        if (l.shouldNormalize(t)) {
          e = l.normalize(e, o, t), i = !0;
          break;
        }
      if (!i)
        throw new Error(`No normalizer found for ${o}`);
    }
    return e;
  }
}
class h {
  constructor(r) {
    a(this, "normalizers");
    this.normalizers = r;
  }
  normalize(r, e, o) {
    const t = `${e}[]`;
    for (const i of o)
      r = this.normalizeArrayItem(r, t, i);
    return r;
  }
  normalizeArrayItem(r, e, o) {
    for (const t of this.normalizers)
      if (t.shouldNormalize(o))
        return t.normalize(r, e, o);
    throw new Error(`No normalizer found for '${o}'`);
  }
  shouldNormalize(r) {
    return Array.isArray(r);
  }
}
class s {
  normalize(r, e, o) {
    return r.append(e, o ? "1" : "0"), r;
  }
  shouldNormalize(r) {
    return typeof r == "boolean";
  }
}
class c {
  normalize(r, e, o) {
    return r.append(e, o.toISOString()), r;
  }
  shouldNormalize(r) {
    return r instanceof Date;
  }
}
class m {
  normalize(r, e, o) {
    return r.append(e, o), r;
  }
  shouldNormalize(r) {
    return r instanceof File;
  }
}
class z {
  normalize(r, e, o) {
    const t = `${e}[]`;
    for (const i of o)
      r.append(t, i);
    return r;
  }
  shouldNormalize(r) {
    return r instanceof FileList;
  }
}
class u {
  normalize(r, e, o) {
    const t = JSON.stringify(o);
    return r.append(e, t), r;
  }
  shouldNormalize(r) {
    return typeof r == "object";
  }
}
class f {
  normalize(r, e, o) {
    return r.append(e, o), r;
  }
  shouldNormalize(r) {
    return typeof r != "object";
  }
}
const p = [
  new z(),
  new h([
    new z(),
    new m(),
    new c(),
    new s(),
    new u(),
    new f()
  ]),
  new m(),
  new c(),
  new s(),
  new u(),
  new f()
], y = new N(p);
function j(n) {
  return y.convertObjectToFormData(n);
}
export {
  j as objectToFormData
};
//# sourceMappingURL=index.es.js.map
